export default {
  "cat.shoes": "Chaussures",
  "cat.hoodies": "Hoodies/Sweats",
  "cat.tshirts": "T-Shirts",
  "cat.jackets": "Vestes",
  "cat.pants": "Pantalons/Shorts",
  "cat.headwear": "Couvre-chefs",
  "cat.sets": "Ensembles",
  "cat.underwear": "Sous-vêtements",
  "cat.jersey": "Maillot",
  "cat.accessories": "Accessoires",
  "cat.bags": "Sacs",
  "cat.belts": "Ceintures",
  "cat.perfumes": "Parfums",
  "cat.other": "Autres articles",
};